// React
import React, { Component } from 'react';
import {functions} from 'constants/index';
// Api Services
import ApiServices from 'services/ApiServices';
// componentes
import Table from 'components/Table';
import Footer from 'pages/Home/Footer2';
import LoadingSpinner from 'components/LoadingSpinner';
// import NewCensusRegistration from './newCensusRegistration';
import {showMessageError} from 'services/SweetAlert'
import ModalCrearEmpadronamientoYActualizacion from './ModalCrearEmpadronamientoYActualizacion';
import Title from 'components/TitleWithIcon';

class EstadisticasEmpadronamientoYActualizacion extends Component {
    constructor(props) {
        super(props);
        this.state = {
            controller:'estadisticaDelegaciones',
            loading: false,
            authorized:true,
            checkAutorization:true,
            data: [],
            header: [
                { title: 'ID', field: 'id',cellStyle:{ maxWidth: '80px' } },
                { title: 'Fecha de Registro de la Estadística', field: 'fechaRegistro', render: (rowData) => functions.splitDate(rowData.fechaRegistro)},
                { title: 'Departamento', field: 'departamento_Registro.name' },
                { title: 'Municipio', field: 'municipio_registro.name',},
                { title: 'Cantidad de Empadronados ', field: 'cantidadEmpadronados'},
                { title: 'Cantidad de Actualizaciones', field: 'cantidadActualizados'},
            ],
            currentUser: props.currentUser,
            showModalNewCensusRegistration: false,
        }
        //declaraciones de todas las funciones que se utilizaran
        this.showList = this.showList.bind(this);
        this.closeModalForNewCensusRegistration = this.closeModalForNewCensusRegistration.bind(this);
    }
        async showList(){
            try{
                this.setState({loading: true, checkAutorization: true});
                const hasPermission = await ApiServices.userSecurity.hasPermission('estadisticasEmpadronamientoYActualizacion','list');
                if (hasPermission.error){
                    this.setState({checkAutorization: false,authorized: false,loading: false });
                }else{
                    ApiServices[this.state.controller].initSearchCriteria.clear();
                    ApiServices[this.state.controller].initSearchCriteria.setOperator("and");
                    ApiServices[this.state.controller].initOrderCriteria.addDesc("id");
                    this.setState({checkAutorization: false, authorized: true,loading: false,data: [], create: false });
                }
            }catch(exception){
                if(exception.status===404) {
                    showMessageError('Oops!','Falla del Sistema. Ponganse en contacto con el Administrador sí este mensaje persiste.')
                }else {
                    showMessageError('Oops!','Intente de nuevo. Ponganse en contacto con el Administrador sí este mensaje persiste.');
                }
                this.setState({ loading: false,checkAutorization: false, data:[]});
            }
        }
        async componentDidMount() {
            this.showList();
        }

      //abrimos el modal para aprobar solicitudes de empadronamiento
    openModalForNewCensusRegistration = async () => {
        this.setState({showModalNewCensusRegistration : true});
    }
    async closeModalForNewCensusRegistration(){
        this.setState({showModalNewCensusRegistration : false});
    }
    render() {
        if (this.state.checkAutorization ) return <LoadingSpinner open={this.state.loading}/>
        // if (!this.state.authorized &&  !this.state.loading){ return <NotAuthorized/>}
        return (
            <div style={{backgroundColor:'#D4D8E1', height: '100%'}}>
                <Title title={'Ingreso de estadísticas de empadronamiento y actualizaciones'} icon={"/menu/partner.svg"}/>
                {this.state.loading ? <LoadingSpinner open={this.state.loading}/> : ""}

                {this.state.showModalNewCensusRegistration && (
                    <ModalCrearEmpadronamientoYActualizacion
                        actualizarTabla={this.showList}
                        open={this.state.showModalNewCensusRegistration}
                        controller={this.state.controller}
                        handleClose={this.closeModalForNewCensusRegistration}
                        principalTitle="Crear estadísticas de empadronamiento y actualizaciones"
                    />
                )}

                <br/><br/>
                    <Table
                        service={ApiServices[this.state.controller]}
                        title={"Listado de estadísticas"}
                        header = {this.state.header}
                        refreshList={this.showList}
                        data={this.state.data}
                        showSearcher={true}
                        addRegister={this.openModalForNewCensusRegistration}
                        nameToolTipAdd="Crear estadística"
                    />
                {/* <br/><br/><br/><Footer /> */}
            </div>
        )
    }
}

export default EstadisticasEmpadronamientoYActualizacion;